import React from "react";
import moment from "moment";

import styles from "./billsPaymentItems.module.css";
import { IMAGE_PATH } from "../../../Utils/variables";
import StatusBadge from "../../Common/StatusBadge";
export const BillsPaymentItems = ({
  id,
  bill_community_id,
  name,
  bill_status,
  bill_approval_status,
  is_normal_bill,
  bill_number,
  bill_date,
  bill_amount,
  handleDetail,
  onClickTabItem,
  activeTabId,
  actual_bill_id,
  bill_ballance_due,
  bill_migrated

}) => {
  let billStatus = "";
  if (is_normal_bill) {
    const amountWithoutCommas = bill_amount?.replace(/,/g, "");
    const parsedBillBalancedue = Number(bill_ballance_due);
    const parsedBillAmount = Number(amountWithoutCommas);

    if (parsedBillBalancedue == 0) {
      billStatus = "paid";
    } else if (parsedBillBalancedue < parsedBillAmount) {
      billStatus = "partially paid";
    } else {
      billStatus = bill_approval_status;
    }
  } else {
    billStatus = bill_status;
  }

  return (
    <>
      <div
        className={
          activeTabId === id
            ? styles.mainDivPOItemsActive + " " + styles.activetab
            : styles.mainDivPOItems
        }
        onClick={() => {
          handleDetail(id, bill_community_id, is_normal_bill);
          onClickTabItem(id);
        }}
      >
        <div className={styles.nameBadgeWrapper}>
          <h1 className={styles.poHeading}>{bill_number}</h1>
          {bill_migrated != '1' && <StatusBadge status={billStatus} actualBillid={actual_bill_id} />}
        </div>
        <div className={styles.ImgPOItems}>
          {activeTabId === id ? (
            <div>
              <img src={IMAGE_PATH + "carbonBuilding.png"} alt="" />
            </div>
          ) : (
            <div>
              <img src={IMAGE_PATH + "carbonBuildingInactive.png"} alt="" />
            </div>
          )}

          <h1>{name}</h1>
        </div>
        <span
          className={
            activeTabId === id
              ? styles.amountDateDivPOItemsActive
              : styles.amountDateDivPOItems
          }
        >
          <p>Bill Date</p>
          <p>Bill Amount</p>
        </span>
        <span
          className={
            activeTabId === id
              ? styles.amountDateValueDivPOItemsActive
              : styles.amountDateValueDivPOItems
          }
        >
          <p>{moment(bill_date).format("DD MMM YYYY")}</p>
          <p>{`${bill_amount} AED`}</p>
        </span>
      </div>
    </>
  );
};
